<template>
    <!-- 搜索表单 -->
    <el-form ref="searchForm" size="small" inline :model="searchForm">
        <el-form-item label="">
            <el-select v-model="searchForm.SourceType" clearable placeholder="课程类型">
                <el-option v-for="(option, key) in PROJECT_TYPE_OPTIONS"
                           :value="parseInt(key)"
                           :label="option"
                           :key="key"/>
            </el-select>
        </el-form-item>
        <el-form-item label="">
            <el-select v-model="searchForm.SourceState" placeholder="状态" clearable>
                <el-option v-for="(value, key) in SOURCE_STATE" :key="key"
                           :label="value" :value="parseInt(key)"/>
            </el-select>
        </el-form-item>
        <el-form-item label="">
            <el-input v-model="searchForm.keyWord" placeholder="请输入关键字搜索" clearable/>
        </el-form-item>
        <el-button type="primary" size="small" icon="el-icon-search" @click.stop="handleSearch"/>
    </el-form>
</template>

<script>
import { PROJECT_TYPE_OPTIONS, SOURCE_STATE } from "../config"
export default {
    name: "SearchForm",
    props: {
        searchForm: {
            type: Object,
            required: true,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            PROJECT_TYPE_OPTIONS,
            SOURCE_STATE
        }
    },
    methods: {
        handleSearch () {
            this.$emit("search")
        }
    }
}
</script>

<style scoped>

</style>
